import { CtaConfiguration } from '@typesApp/Cta'
import { Form, Section } from '@typesApp/DynamicComponent'

export const transformCtaState = (payload: Record<string, object>): CtaConfiguration => {
  return {
    ineligibleCart: payload.ineligibleCart,
    loggedIn: {
      ACCEPTED: payload.accepted,
      ACKNOWLEDGED_NULLIFIED: payload.acknowledgedNullified,
      DEFAULT: payload.default,
      IN_PROGRESS: payload.inProgress,
      LIMIT_REACHED: payload.limitReached,
      NULLIFIED: payload.nullified,
      REJECTED: payload.rejected,
      SERVICE_OFFLINE: payload.serviceOffline,
      NULLIFY_REJECTED: payload.nullifyRejected,
    },
  } as CtaConfiguration
}

export const transformIntroForm = (payload: Record<string, object>): Form => {
  const form = {
    sections: [] as Section[],
    ...payload.main,
  } as Form

  // need to add sections as they are returned in separate attributes
  // within the payload (due to 4K limit on json size)
  for (let i = 0; ; i++) {
    const section = payload[`section${i}`]
    if (!section || Object.keys(section).length === 0) {
      break
    } else {
      form?.sections?.push(section as Section)
    }
  }
  return form
}
